import { ITrackingStatus } from '@packlink/packlink-sdk';
import { getRootTrackingStatus } from '../../../utils/TrackingStatus.js';

function getTrackingStatusIconColors(status, theme) {
  const rootStatus = getRootTrackingStatus(status);
  switch (rootStatus) {
    case ITrackingStatus.DELIVERED:
      return {
        backgroundColor: theme.palette.success.light,
        color: theme.palette.gray.dark
      };
    case ITrackingStatus.IN_TRANSIT:
      return {
        backgroundColor: theme.palette.alert.light,
        color: theme.palette.gray.dark
      };
    case ITrackingStatus.OUT_FOR_DELIVERY:
    case ITrackingStatus.READY_FOR_COLLECTION:
      return {
        backgroundColor: theme.palette.info.light,
        color: theme.palette.gray.dark
      };
    case ITrackingStatus.EXCEPTION:
    case ITrackingStatus.IN_TRANSIT_INCIDENT:
    case ITrackingStatus.OUT_FOR_DELIVERY_INCIDENT:
    case ITrackingStatus.READY_FOR_COLLECTION_INCIDENT:
      return {
        backgroundColor: theme.palette.error.light,
        color: theme.palette.error.main
      };
    case ITrackingStatus.RETURNED_TO_SENDER:
    default:
      return {
        backgroundColor: theme.palette.gray.light,
        color: theme.palette.gray.dark
      };
  }
}
const getParcelTrackingStatusIconStyles = status => theme => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  width: theme.spacing(3),
  height: theme.spacing(3),
  ...getTrackingStatusIconColors(status, theme)
});

export { getParcelTrackingStatusIconStyles };
//# sourceMappingURL=ParcelTrackingStatusIconStyles.js.map
